import { ChartContainer } from './ChartContainer';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { Badge } from '../ui/badge';

export const TopPagesTable = ({ data }) => {
  return (
    <ChartContainer 
      title="Top Pages" 
      subtitle="Most visited sections"
      className="col-span-2"
    >
      <div className="overflow-x-auto" data-testid="top-pages-table">
        <Table>
          <TableHeader>
            <TableRow className="border-white/5 hover:bg-transparent">
              <TableHead className="text-muted-foreground font-manrope text-xs uppercase tracking-wider">Page</TableHead>
              <TableHead className="text-muted-foreground font-manrope text-xs uppercase tracking-wider text-right">Views</TableHead>
              <TableHead className="text-muted-foreground font-manrope text-xs uppercase tracking-wider text-right hidden sm:table-cell">Avg. Time</TableHead>
              <TableHead className="text-muted-foreground font-manrope text-xs uppercase tracking-wider text-right hidden md:table-cell">Bounce Rate</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((page, index) => (
              <TableRow 
                key={index} 
                className="border-white/5 hover:bg-white/5 transition-colors"
              >
                <TableCell className="font-manrope">
                  <div>
                    <div className="text-foreground font-medium">{page.title}</div>
                    <div className="text-muted-foreground text-xs mt-0.5">{page.page}</div>
                  </div>
                </TableCell>
                <TableCell className="text-right font-manrope font-medium text-foreground">
                  {page.views.toLocaleString()}
                </TableCell>
                <TableCell className="text-right font-manrope text-muted-foreground hidden sm:table-cell">
                  {page.avgTime}
                </TableCell>
                <TableCell className="text-right hidden md:table-cell">
                  <Badge 
                    variant="secondary" 
                    className={`font-manrope ${
                      page.bounceRate < 25 
                        ? 'bg-emerald-400/10 text-emerald-400' 
                        : page.bounceRate < 30 
                          ? 'bg-primary/10 text-primary' 
                          : 'bg-secondary text-muted-foreground'
                    }`}
                  >
                    {page.bounceRate}%
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </ChartContainer>
  );
};
